import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from '..';
import {IRelease, IChange} from 'app/types/Shared';
import {changeApi} from './changeApi';

export interface IChangeState {
  allReleases: Array<IRelease>;
  allChanges: Array<IChange>;
  latestRelease?: IRelease;
  newProcesses: Array<IChange>;
}

export const initialState: IChangeState = {
  allReleases: [],
  allChanges: [],
  latestRelease: undefined,
  newProcesses: [],
};

export const changesSlice = createSlice({
  name: 'changes',
  initialState,
  reducers: {
    setLatestRelease: (state, {payload}: PayloadAction<IRelease>) => {
      state.latestRelease = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(changeApi.endpoints.getAllReleases.matchFulfilled, (state, {payload}) => {
      state.allReleases = payload;
    });
    builder.addMatcher(changeApi.endpoints.getChangesByRelease.matchFulfilled, (state, {payload}) => {
      state.allChanges = payload;
    });
    builder.addMatcher(changeApi.endpoints.getNewProcesses.matchFulfilled, (state, {payload}) => {
      state.newProcesses = payload;
    });
  },
});

export const {setLatestRelease} = changesSlice.actions;

export const selectAllChanges = (state: RootState) => state.changes.allChanges;
export const selectAllReleases = (state: RootState) => state.changes.allReleases;
export const selectLatestRelease = (state: RootState) => state.changes.latestRelease;
export const selectNewProccess = (state: RootState) => state.changes.newProcesses;
export default changesSlice.reducer;
